<template>
    <!-- Testimonials Section -->
    <div class="py-12 md:py-20 px-4 md:px-8">
        <div class="max-w-5xl mx-auto">
            <div class="text-center mb-12">
                <p class="text-slate-800 dark:text-slate-100 text-2xl md:text-4xl">
                    What our
                    <span class="text-orange font-medium">members</span>
                    are saying
                </p>
            </div>

            <!-- Grid for 3 or fewer testimonials -->
            <div
                v-if="testimonials.length <= 3"
                class="grid grid-cols-1 md:grid-cols-3 gap-6 items-start"
            >
                <div
                    v-for="(testimonial, index) in testimonials"
                    :key="index"
                    class="p-6 bg-white dark:bg-slate-800 rounded shadow-sm"
                >
                    <div class="flex gap-1 mb-4">
                        <Icon
                            v-for="n in 5"
                            :key="n"
                            icon="star-filled"
                            class="w-4 h-4 text-orange"
                        />
                    </div>
                    <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-4">
                        "{{ testimonial.text }}"
                    </p>
                    <div class="flex items-center gap-3">
                        <div
                            class="w-10 h-10 bg-slate-200 dark:bg-slate-700 rounded-full flex items-center justify-center"
                        >
                            <span
                                class="text-sm font-medium text-slate-600 dark:text-slate-300"
                            >
                                {{ testimonial.initials }}
                            </span>
                        </div>
                        <div>
                            <p class="text-sm font-medium text-slate-800 dark:text-slate-100">
                                {{ testimonial.name }}
                            </p>
                            <p class="text-xs text-slate-500 dark:text-slate-400">
                                {{ testimonial.title }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Carousel for more than 3 testimonials -->
            <CardCarousel
                v-else
                :cards="testimonials"
                :num-cards="testimonials.length"
                :card-width="320"
                :pagination="false"
            >
                <template #carouselCard="{ card }">
                    <div
                        class="p-6 mr-4 h-full flex flex-col bg-white dark:bg-slate-800 rounded shadow-sm w-[320px]"
                    >
                        <div class="flex gap-1 mb-4">
                            <Icon
                                v-for="n in 5"
                                :key="n"
                                icon="star-filled"
                                class="w-4 h-4 text-orange"
                            />
                        </div>
                        <p
                            class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-4 grow"
                        >
                            "{{ card.text }}"
                        </p>
                        <div class="flex items-center gap-3 mt-auto">
                            <div
                                class="w-10 h-10 bg-slate-200 dark:bg-slate-700 rounded-full flex items-center justify-center"
                            >
                                <span
                                    class="text-sm font-medium text-slate-600 dark:text-slate-300"
                                >
                                    {{ card.initials }}
                                </span>
                            </div>
                            <div>
                                <p
                                    class="text-sm font-medium text-slate-800 dark:text-slate-100"
                                >
                                    {{ card.name }}
                                </p>
                                <p class="text-xs text-slate-500 dark:text-slate-400">
                                    {{ card.title }}
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </CardCarousel>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import CardCarousel from '@/components/ui/card-carousel/card-carousel.vue';

const testimonials = [
    {
        text: "Just finished up with 10xTravel and I'm absolutely blown away. I recommend this for anyone who wants to maximize their credit card points.",
        name: 'Alex',
        initials: 'A',
        title: 'Member since 2023',
    },
    {
        text: "I was skeptical at first, but 10xTravel's community and tools have completely changed how I approach travel. The free booking alone paid for my membership.",
        name: 'Sarah M.',
        initials: 'SM',
        title: 'Member since 2022',
    },
    {
        text: "I've been using 10xTravel+ for 6 months now and I've already saved over $2,000 on flights. The benefits tracker is a game-changer.",
        name: 'Michael R.',
        initials: 'MR',
        title: 'Member since 2024',
    },
    {
        text: 'Just wow!',
        name: 'Erin',
        initials: 'E',
        title: 'Member since 2025',
    },
    {
        text: "Just teamed up with 10xTravel and I'm absolutely blown away. I recommend this for anyone who wants to maximize their credit card points.",
        name: 'McKenzie',
        initials: 'R',
        title: 'Member since 2021',
    },
];
</script>

<style scoped>
:deep(.carousel) {
    position: relative;
}

:deep(.carousel__prev),
:deep(.carousel__next) {
    position: absolute;
    top: 0;
    transform: translateY(0);
}

:deep(.carousel__prev) {
    left: -40px;
}

:deep(.carousel__next) {
    right: -40px;
}
</style>
